import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import QRCode from "qrcode";
import SendMessage from "@/components/SendMessage.vue";
import SafetyCodeInput from "../Common/SafetyCodeInput.vue";
import { validateMFA, unbindMFA, validCode } from "@/service/version";
import { mobileVerificationCode, emailVerificationCode, getUserInfo } from "@/service/user";
import { mapActions, mapState } from "vuex/dist/vuex.common.js";
import Cookies from "js-cookie";
export default {
  props: {
    closeable: {
      type: Boolean,
      default: true
    },
    units: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      protection: false,
      // 记录本次关闭是否由用户取消触发，避免成功关闭被误报为 validCancel。
      emitCancelOnClose: true,
      unitCode: null,
      isMobile: false,
      //   绑定 or 解绑
      flag: true,
      title: $t("a6rayn5", "绑定MFA"),
      currentStep: 0,
      userInfo: {},
      personalConfig: JSON.parse(localStorage.getItem("personalConfig")),
      qrcodeDataUrl: "",
      // 用于存储二维码的dataURL
      removeStepList: [{
        title: $t("bw8bfg4", "安全认证"),
        content: ""
      }, {
        title: $t("g3yc2", "完成"),
        content: ""
      }],
      bindStepList: [{
        title: $t("bw8bfg4", "安全认证"),
        content: ""
      }, {
        title: $t("afuf6u4", "下载应用"),
        content: ""
      }, {
        title: $t("a6rayn5", "绑定MFA"),
        content: ""
      }, {
        title: $t("g3yc2", "完成"),
        content: ""
      }],
      identifyTypeList: [{
        label: $t("padf2", "邮箱"),
        value: "EMAIL"
      }, {
        label: $t("haa72", "手机"),
        value: "MOBILE"
      }],
      mobileList: [$t("ibh8tgp", "1、手机号码可能是为欠费停机状态，请及时充缴话费。"), $t("p9mzr4s", "2、短信发送超过当天频次限制，国内短信24小时限制5次。"), $t("dp9kk0s", "3、手机短信收件箱过满或手机内存不足，需清空后重启手机。"), $t("n21z414", "4、手机型号为双卡双待，请确认AB卡槽是否正确安放（可尝试更换AB卡位置重试）。"), $t("sjqkewg", "5、手机可能开启短信防骚扰功能。"), $t("lbfxc2i", "6、如仍无法解决，请联系管理员咨询。")],
      emailList: [$t("3rhkdf13", "1、请确认邮箱是否设置垃圾邮件自动过滤，可进入垃圾箱查找含“绿云”发送的邮件。"), $t("x8z5rz1e", "2、请确认绿云的邮件地址是否被列入了黑名单；可将邮件地址：XXXX@green.com从黑名单移除。"), $t("kqu9z21o", "3、请确认绑定安全邮箱是否为可用状态，若绑定邮箱已注销停用，请通过联系您的销售或代理商，提供相关资质信息后更换安全邮箱。"), $t("gqeoqki", "4、如仍无法解决，请联系管理员咨询。")],
      form: {
        email: this.mobileEmail.email,
        mobile: this.mobileEmail.mobile,
        verificationCode: "",
        mobileAreaCode: this.mobileEmail.mobileAreaCode || "+86",
        identifyType: "mobile"
      },
      rules: {
        email: [{
          required: true,
          validator: this.validEmail,
          trigger: "blur"
        }],
        verificationCode: [{
          required: true,
          // message: "验证码不能为空",
          trigger: "blur,change"
        }]
      },
      identifyMFAForm: {
        identifyMFACode: ""
      },
      identifyMFARules: {
        identifyMFACode: [{
          required: true,
          message: `${$t("9xs6f97", "安全码格式有误")} `,
          trigger: "change,blur"
        }, {
          pattern: /\d{6}/,
          message: `${$t("9xs6f97", "安全码格式有误")} `,
          trigger: "change,blur"
        }]
      },
      productForm: {
        productCode: ""
      },
      productRules: {
        productCode: [{
          required: true,
          message: `${$t("9xs6f97", "安全码格式有误")} `,
          trigger: "change,blur"
        }, {
          pattern: /\d{6}/,
          message: `${$t("9xs6f97", "安全码格式有误")} `,
          trigger: "change,blur"
        }]
      },
      countdown: 0,
      timer: null,
      accountType: "MOBILE",
      mobileEmailInfo: {
        email: "",
        mobile: ""
      }
    };
  },
  beforeMount() {
    // 获取视口宽度
    this.screenWidth = document.body.clientWidth;
    this.isMobile = this.screenWidth < 500;
  },
  methods: {
    ...mapActions(["handleLogin", "handlePhoneSubmit"]),
    async onEnter() {
      var valid = await this.$refs.sendMessage.validate();
      if (!valid) {
        return;
      }
      var {
        mobile,
        mobileAreaCode,
        verificationCode,
        email
      } = this.form;
      var {
        data: {
          result
        }
      } = await validCode({
        email,
        mobile,
        userId: this.userInfo.userId,
        authMode: this.accountType,
        mobileAreaCode,
        verificationCode,
        checkMode: "CHECK"
      });
      if (result === 0) {
        this.currentStep = 1;
      }
    },
    async onValid() {
      this.$refs["validForm"].validate(async data => {
        if (data.valid) {
          let {
            data: {
              result
            }
          } = await validateMFA({
            code: data.code,
            unitId: Cookies.get("unitId")
          });
          if (result === 0) {
            this.currentStep = 3;
            this.$emit("validSuccess");
          }
        } else {
          return false;
        }
      });
    },
    async onValidate() {
      this.$refs["validForm"].validate(async data => {
        if (data.valid) {
          let {
            data: {
              result
            }
          } = await unbindMFA({
            code: data.code
          });
          if (result === 0) {
            this.currentStep = 1;
          }
        } else {
          return false;
        }
      });
    },
    validEmail(rule, value, callback) {
      let reg = /.*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (value === "") {
        callback(new Error($t("irio214", "邮箱必填")));
      } else if (value && !reg.test(value)) {
        callback(new Error($t("venleq7", "邮箱格式不正确")));
      } else if (value.length > 50) {
        callback(new Error($t("venleq7", "邮箱格式不正确")));
      } else {
        callback();
      }
    },
    mobileEmail(e) {
      this.mobileEmailInfo = {
        ...this.mobileEmailInfo,
        ...e
      };
    },
    changeLoginType(value) {
      var _this$$refs$sendMessa;
      this.accountType = value;
      this.form.identifyType = value;
      this.form.mobileAreaCode = "+86";
      // 切换验证方式时只清理验证码态，避免把已加载的手机号/邮箱展示值重置为空。
      (_this$$refs$sendMessa = this.$refs.sendMessage) === null || _this$$refs$sendMessa === void 0 || _this$$refs$sendMessa.clearVerificationState();
    },
    clean() {
      var _this$$refs$sendMessa2, _this$$refs$sendMessa3;
      (_this$$refs$sendMessa2 = this.$refs.sendMessage) === null || _this$$refs$sendMessa2 === void 0 || _this$$refs$sendMessa2.clearVerificationCode();
      (_this$$refs$sendMessa3 = this.$refs.sendMessage) === null || _this$$refs$sendMessa3 === void 0 || _this$$refs$sendMessa3.clean();
    },
    backToIndex() {
      // 完成绑定或解绑后返回工作台属于成功关闭，不能再触发取消登录逻辑。
      this.close(false);
      this.$store.commit("setActiveMenu", {
        link: "/MGT",
        name: "enterpriseHome",
        label: $t("e529l3", "工作台"),
        svg: "",
        children: []
      });
      this.$router.push("/MGT");
      console.log("触发通知");

      // 总线事件
      this.$bus.$emit("selectMenu", {
        link: "/MGT",
        name: "enterpriseHome"
      });
    },
    async open(config, unitCode) {
      let {
        bound
      } = config;
      this.emitCancelOnClose = true;
      this.flag = bound;
      this.title = bound ? $t("d47io65", "解绑MFA") : $t("a6rayn5", "绑定MFA");
      this.currentStep = 0;
      this.personalConfig = config;
      this.unitCode = unitCode;
      this.protection = true;
    },
    close(emitCancel = true) {
      // Button 点击时会传入事件对象；只有显式传入 false 才表示成功关闭。
      this.emitCancelOnClose = emitCancel !== false;
      this.protection = false;
    },
    async onClose(value) {
      if (!value) {
        const shouldEmitCancel = this.emitCancelOnClose;
        this.emitCancelOnClose = true;
        this.resetData();
        this.clean();
        // visible-change 是关闭的统一出口，确保一次关闭只通知一次取消事件。
        if (shouldEmitCancel) {
          this.$emit("validCancel");
        }
      } else {
        await this.getFormInfo();
        this.initLoginType();
      }
    },
    async nextStep() {
      // let that = this;
      if (!this.flag) {
        switch (this.currentStep) {
          case 0:
            this.onEnter();
            break;
          case 1:
            await this.getProductCode();
            this.currentStep = 2;
            break;
          case 2:
            this.onValid();
            break;
          case 3:
            break;
        }
      } else {
        switch (this.currentStep) {
          case 0:
            this.onValidate();
            break;
          case 1:
            break;
        }
      }
    },
    sendIdentifyCode() {
      if (this.countdown > 0 || !this.form.mobile) return;
      this.$refs.verify.show();
    },
    resetData() {
      var _this$$refs$productFo, _this$$refs$identifyF;
      this.currentStep = 0;
      Object.assign(this.form, {
        mobileAreaCode: "+86"
      });
      Object.assign(this.productForm, {
        productCode: ""
      });
      (_this$$refs$productFo = this.$refs["productForm"]) === null || _this$$refs$productFo === void 0 || _this$$refs$productFo.resetFields();
      (_this$$refs$identifyF = this.$refs["identifyForm"]) === null || _this$$refs$identifyF === void 0 || _this$$refs$identifyF.resetFields();
    },
    getProductCode() {
      // 确保qrcode数据存在
      if (!this.personalConfig || !this.personalConfig.qrcode) {
        console.error("QRCode data is missing");
        return;
      }
      console.log("QRCode data:", this.personalConfig.qrcode);

      // 直接使用toDataURL方法生成二维码并存储到数据属性
      QRCode.toDataURL(this.personalConfig.qrcode, {
        width: 200,
        margin: 1,
        color: {
          dark: "#000000",
          light: "#ffffff"
        },
        errorCorrectionLevel: "H"
      }, (error, url) => {
        if (error) {
          console.error("QRCode generation error:", error);
        } else {
          console.log("QRCode dataURL generated successfully:", url.substring(0, 50) + "...");
          // 直接将dataURL保存到响应式数据属性
          this.qrcodeDataUrl = url;
        }
      });
    },
    async getFormInfo() {
      let {
        data: {
          retVal: userInfo
        }
      } = await getUserInfo();
      this.userInfo = userInfo;
      this.form.mobile = userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobile;
      this.form.email = userInfo === null || userInfo === void 0 ? void 0 : userInfo.email;
      if (this.form.mobile.indexOf("+") > -1) {
        //手机号存在区号 拆分区号和手机号
        const arr = this.form.mobile.split("-");
        this.form.mobileAreaCode = arr[0];
        this.form.mobile = arr[1];
      }
    },
    async success(value) {
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
      if (this.accountType === "MOBILE") {
        await mobileVerificationCode(this.form.mobile, value.captchaVerification, "LOGIN", this.form.mobileAreaCode);
      } else {
        await emailVerificationCode(this.value.email, value.captchaVerification, this.mode);
      }
    },
    initLoginType() {
      if (this.userInfo.mobile && this.userInfo.email) {
        this.accountType = "MOBILE";
      } else if (this.userInfo.email) {
        this.accountType = "EMAIL";
      } else if (this.userInfo.mobile) {
        this.accountType = "MOBILE";
      }
    }
  },
  computed: {
    ...mapState({
      personalConfig: state => state.user.personalConfig,
      user: state => state.user
    }),
    compUtedUnitCode() {
      let unit = localStorage.getItem("unit");
      let current = unit ? JSON.parse(unit) : {};
      return this.unitCode || current.code;
    },
    currentTipList() {
      return this.accountType === "EMAIL" ? this.emailList : this.mobileList;
    }
  },
  components: {
    SendMessage,
    SafetyCodeInput
  }
};